import { createSelector } from "reselect";
import every from "lodash/every";

const makeBackendsErrorSelection = (backends) =>
  createSelector(() => every(backends, ["status", "ERROR"]));

export { makeBackendsErrorSelection };

export default {
  makeBackendsErrorSelection,
};
